export enum ActionTypes {
  UPDATE_CAPTCHA_RESPONSE = 'UPDATE_CAPTCHA_RESPONSE',
  UPDATE_VALUE = 'UPDATE_VALUE',
  LOAD_DEFAULT_VALUE = 'LOAD_DEFAULT_VALUE',
  UPDATE_LINK_TYPE = 'UPDATE_LINK_TYPE',
  LOAD_DEFAULT_TABLE_VALUES = 'LOAD_DEFAULT_TABLE_VALUES',
  UPDATE_TABLE_VALUES = 'UPDATE_TABLE_VALUES',
  UPDATE_VALUES = 'UPDATE_VALUES'
}
